import { css } from "@emotion/react";
import { MediumText } from "../../../styles/styles";
import { BLACK, WHITE } from "../../../styles/colors";
import { ERROR_BORDER, WARNING_BORDER } from "../../../forms/styles";
import styled from "@emotion/styled";

export const validationStyles = {
  errorMessage: css`
    ${MediumText};
    background-color: ${BLACK};
    color: ${WHITE};
    padding: 10px;
    white-space: pre-line;
    max-width: 250px;
    border-radius: 0.5rem;
  `,

  errorBorder: css`
    ${ERROR_BORDER};
    box-sizing: border-box;
  `,

  warningBorder: css`
    ${WARNING_BORDER};
    box-sizing: border-box;
  `,
};


export const ErrorSlot = styled('div')`
  width: 30px;
  height: 30px;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorImage = styled('img')`
  width: 25px;
  height: 25px;
  padding: 3px;
  transition: opacity 120ms ease-in;
  transform: translateY(2px);
`;
